import { render, staticRenderFns } from "./LabelValue.vue?vue&type=template&id=e9843794&scoped=true&"
import script from "./LabelValue.vue?vue&type=script&lang=js&"
export * from "./LabelValue.vue?vue&type=script&lang=js&"
import style0 from "./LabelValue.vue?vue&type=style&index=0&id=e9843794&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9843794",
  null
  
)

export default component.exports